export default __webpack_public_path__ + "static/media/logo-renart.2b5b1671.svg";